// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.print-btn-wrap {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0;
}

.print-settings-panel {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: 4px;
  z-index: 300;
  min-width: 190px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.45);
}

.print-size-row {
  display: flex;
  gap: 4px;
  padding: 8px 12px 6px;
  border-bottom: 1px solid var(--border);
}
.print-size-btn {
  flex: 1;
  padding: 3px 0;
  border: 1px solid var(--border);
  border-radius: 3px;
  background: none;
  color: var(--text-secondary);
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}
.print-size-btn.active {
  background: var(--accent-light);
  color: #fff;
  border-color: var(--accent-light);
}

.print-settings-title {
  font-size: 10px;
  font-weight: 700;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 8px 12px 6px;
  border-bottom: 1px solid var(--border);
}

.print-settings-list {
  max-height: 320px;
  overflow-y: auto;
  padding: 4px 0;
}

.print-settings-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 12px;
  font-size: 12px;
  color: var(--text-secondary);
  cursor: pointer;
  user-select: none;
}
.print-settings-item:hover { background: var(--bg-hover); color: var(--text-primary); }
.print-settings-item input { cursor: pointer; flex-shrink: 0; }

/* Print destination menu */
.print-menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 7px 12px;
  background: none;
  border: none;
  color: var(--text-secondary);
  font-size: 12px;
  text-align: left;
  cursor: pointer;
  border-radius: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 260px;
}
.print-menu-item:hover { background: var(--bg-hover); color: var(--text-primary); }
.print-menu-item:disabled { opacity: 0.4; cursor: default; }
.print-menu-sep { height: 1px; background: var(--border); margin: 4px 0; }
.print-menu-muted {
  padding: 6px 12px;
  font-size: 11px;
  color: var(--text-muted);
}
`, "",{"version":3,"sources":["webpack://./src/components/common/PrintButton.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;EACrB,sCAAsC;AACxC;AACA;EACE,OAAO;EACP,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,+BAA+B;EAC/B,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;AACnB;AACA,6BAA6B,2BAA2B,EAAE,0BAA0B,EAAE;AACtF,6BAA6B,eAAe,EAAE,cAAc,EAAE;;AAE9D,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA,yBAAyB,2BAA2B,EAAE,0BAA0B,EAAE;AAClF,4BAA4B,YAAY,EAAE,eAAe,EAAE;AAC3D,kBAAkB,WAAW,EAAE,yBAAyB,EAAE,aAAa,EAAE;AACzE;EACE,iBAAiB;EACjB,eAAe;EACf,wBAAwB;AAC1B","sourcesContent":[".print-btn-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 0;\n}\n\n.print-settings-panel {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  z-index: 300;\n  min-width: 190px;\n  box-shadow: 0 6px 20px rgba(0,0,0,0.45);\n}\n\n.print-size-row {\n  display: flex;\n  gap: 4px;\n  padding: 8px 12px 6px;\n  border-bottom: 1px solid var(--border);\n}\n.print-size-btn {\n  flex: 1;\n  padding: 3px 0;\n  border: 1px solid var(--border);\n  border-radius: 3px;\n  background: none;\n  color: var(--text-secondary);\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.print-size-btn.active {\n  background: var(--accent-light);\n  color: #fff;\n  border-color: var(--accent-light);\n}\n\n.print-settings-title {\n  font-size: 10px;\n  font-weight: 700;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 8px 12px 6px;\n  border-bottom: 1px solid var(--border);\n}\n\n.print-settings-list {\n  max-height: 320px;\n  overflow-y: auto;\n  padding: 4px 0;\n}\n\n.print-settings-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 5px 12px;\n  font-size: 12px;\n  color: var(--text-secondary);\n  cursor: pointer;\n  user-select: none;\n}\n.print-settings-item:hover { background: var(--bg-hover); color: var(--text-primary); }\n.print-settings-item input { cursor: pointer; flex-shrink: 0; }\n\n/* Print destination menu */\n.print-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 7px 12px;\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  font-size: 12px;\n  text-align: left;\n  cursor: pointer;\n  border-radius: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 260px;\n}\n.print-menu-item:hover { background: var(--bg-hover); color: var(--text-primary); }\n.print-menu-item:disabled { opacity: 0.4; cursor: default; }\n.print-menu-sep { height: 1px; background: var(--border); margin: 4px 0; }\n.print-menu-muted {\n  padding: 6px 12px;\n  font-size: 11px;\n  color: var(--text-muted);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
